import React, { useState } from 'react'
import ContactMailIcon from '@material-ui/icons/ContactMail'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardIcon from 'src/components/sharedComponents/Card/CardIcon'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import Card from 'src/components/sharedComponents/Card/Card'
import CardFooter from 'src/components/sharedComponents/Card/CardFooter'
import CustomInput from 'src/components/sharedComponents/CustomInput/CustomInput'

const Finder = (props) => {
  const { handlerSubmit } = props
  const [documentInput, setDocumentInput] = useState('')

  const onChange = (e) => {
    setDocumentInput(e.target.value)
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        handlerSubmit(documentInput)
      }}
    >
      <Card>
        <CardHeader color="customAuteco" stats icon>
          <CardIcon color="customAuteco">
            <ContactMailIcon />
          </CardIcon>
        </CardHeader>
        <CardBody>
          <CustomInput
            labelText='Busque por placa (mayúsculas) o documentos (cédulas) separados por coma ","'
            id="placa"
            value={documentInput}
            required
            formControlProps={{
              fullWidth: true,
              required: true,
            }}
            inputProps={{
              onChange,
              autoComplete: 'on',
            }}
          />
        </CardBody>
        <CardFooter>
          <Button type="onSubmit " color="warning">
            Buscar documento o placa
          </Button>
        </CardFooter>
      </Card>
    </form>
  )
}

export default Finder
